module.exports = __webpack_public_path__ + "img/new_index_cases21.5df95152.png";